/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AvailableLegalEntitiesResponse } from '../models/AvailableLegalEntitiesResponse';
import type { CreateRiskGroupRequest } from '../models/CreateRiskGroupRequest';
import type { CreateRiskGroupResponse } from '../models/CreateRiskGroupResponse';
import type { Gender } from '../models/Gender';
import type { GetRiskGroupListResponse } from '../models/GetRiskGroupListResponse';
import type { GetRiskGroupPersonResponse } from '../models/GetRiskGroupPersonResponse';
import type { GetRiskGroupPersonsResponse } from '../models/GetRiskGroupPersonsResponse';
import type { GetRiskGroupResponse } from '../models/GetRiskGroupResponse';
import type { ListSortDirection } from '../models/ListSortDirection';
import type { PersonCaseStatus } from '../models/PersonCaseStatus';
import type { RiskGroupStatus } from '../models/RiskGroupStatus';
import type { UpdateRiskGroupLegalEntityRequest } from '../models/UpdateRiskGroupLegalEntityRequest';
import type { UpdateRiskGroupLegalEntityResponse } from '../models/UpdateRiskGroupLegalEntityResponse';
import type { UpdateRiskGroupPersonRequest } from '../models/UpdateRiskGroupPersonRequest';
import type { UpdateRiskGroupPersonResponse } from '../models/UpdateRiskGroupPersonResponse';
import type { UpdateRiskGroupRequest } from '../models/UpdateRiskGroupRequest';
import type { UpdateRiskGroupResponse } from '../models/UpdateRiskGroupResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PreScreeningService {
    /**
     * Update the legal entity associated with a Risk Group.
     * Updates the legal entity of an existing Risk Group by modifying its legal entity ID and related document information.
     * @param id
     * @param requestBody
     * @returns UpdateRiskGroupLegalEntityResponse The legal entity of the Risk Group has been updated successfully.
     * @throws ApiError
     */
    public static updateRiskGroupLegalEntityEndpoint(
        id: string,
        requestBody: UpdateRiskGroupLegalEntityRequest,
    ): CancelablePromise<UpdateRiskGroupLegalEntityResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/risk-groups/{id}/legal-entity',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid request. Required parameters are missing or invalid.`,
                401: `User is not authorized.`,
                403: `User is forbidden from performing this operation.`,
                404: `The specified Risk Group or Legal Entity was not found.`,
            },
        });
    }
    /**
     * Update an existing Risk Group.
     * Updates the details of an existing Risk Group, including its title, document information, legal entity, and associated person links.
     * @param id
     * @param requestBody
     * @returns UpdateRiskGroupResponse The Risk Group has been updated successfully.
     * @throws ApiError
     */
    public static updateRiskGroupEndpoint(
        id: string,
        requestBody: UpdateRiskGroupRequest,
    ): CancelablePromise<UpdateRiskGroupResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/risk-groups/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid request. Required parameters are missing or invalid.`,
                401: `User is not authorized.`,
                403: `User is forbidden from performing this operation.`,
                404: `The specified Risk Group was not found.`,
            },
        });
    }
    /**
     * Retrieve details of a Risk Group.
     * Provides information about a specific Risk Group, including its associated counts and legal entity details.
     * @param id
     * @returns GetRiskGroupResponse The Risk Group details have been retrieved successfully.
     * @throws ApiError
     */
    public static getRiskGroupEndpoint(
        id: string,
    ): CancelablePromise<GetRiskGroupResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/risk-groups/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided or are invalid.`,
                401: `The user is not authorized to access this resource.`,
                403: `The user is not authorized to access this resource.`,
                404: `The Risk Group not found.`,
            },
        });
    }
    /**
     * Delete a Risk group.
     * Delete a Risk group.
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static deleteRiskGroupEndpoint(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/risk-groups/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Sends the selected risk group to a legal entity.
     * This endpoint allows users to submit a risk group to the assigned legal entity.
     * Once sent, the risk group cannot be modified or deleted.
     * @param riskGroupId
     * @returns any Risk group successfully sent to the legal entity.
     * @throws ApiError
     */
    public static sendToLegalEntityEndpoint(
        riskGroupId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/risk-groups/{riskGroupId}/send-to-legal-entity',
            path: {
                'riskGroupId': riskGroupId,
            },
            errors: {
                400: `Invalid request. Missing or incorrect data.`,
                401: `Unauthorized. User must be authenticated.`,
                403: `Forbidden. User lacks the necessary permissions.`,
                404: `Risk group or legal entity not found.`,
            },
        });
    }
    /**
     * Update the association of a specific person with a Risk Group.
     * Updates the details of a specific person linked to a Risk Group, the screening date and screening status.
     * @param riskGroupId
     * @param personId
     * @param requestBody
     * @returns UpdateRiskGroupPersonResponse The person's association with the Risk Group has been updated successfully.
     * @throws ApiError
     */
    public static updateRiskGroupPersonEndpoint(
        riskGroupId: string,
        personId: string,
        requestBody: UpdateRiskGroupPersonRequest,
    ): CancelablePromise<UpdateRiskGroupPersonResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/risk-groups/{riskGroupId}/persons/{personId}',
            path: {
                'riskGroupId': riskGroupId,
                'personId': personId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided or are invalid.`,
                401: `The user is not authorized to access this resource.`,
                403: `The user is forbidden from accessing this resource.`,
                404: `The specified Risk Group or Person was not found.`,
            },
        });
    }
    /**
     * Retrieve a specific person link associated with a Risk Group.
     * Provides detailed information about a specific person linked to a Risk Group, including their addresses, screening date, and status.
     * @param riskGroupId
     * @param personId
     * @returns GetRiskGroupPersonResponse The person link for the Risk Group has been retrieved successfully.
     * @throws ApiError
     */
    public static getRiskGroupPersonEndpoint(
        riskGroupId: string,
        personId: string,
    ): CancelablePromise<GetRiskGroupPersonResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/risk-groups/{riskGroupId}/persons/{personId}',
            path: {
                'riskGroupId': riskGroupId,
                'personId': personId,
            },
            errors: {
                400: `The required parameters were not provided or are invalid.`,
                401: `The user is not authorized to access this resource.`,
                403: `The user is forbidden from accessing this resource.`,
                404: `The specified Risk Group or Person was not found.`,
            },
        });
    }
    /**
     * Remove the association of a specific person with a Risk Group.
     * Deletes the link between a specific person and a Risk Group.
     * @param riskGroupId
     * @param personId
     * @returns void
     * @throws ApiError
     */
    public static deleteRiskGroupPersonEndpoint(
        riskGroupId: string,
        personId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/risk-groups/{riskGroupId}/persons/{personId}',
            path: {
                'riskGroupId': riskGroupId,
                'personId': personId,
            },
            errors: {
                400: `The required parameters were not provided or are invalid.`,
                401: `The user is not authorized to access this resource.`,
                403: `The user is forbidden from accessing this resource.`,
                404: `The specified Risk Group or Person was not found.`,
            },
        });
    }
    /**
     * Add a person to a Risk Group.
     * Associates a specific person with a Risk Group by linking their ID to the group.
     * @param riskGroupId
     * @param personId
     * @returns void
     * @throws ApiError
     */
    public static addRiskGroupPersonEndpoint(
        riskGroupId: string,
        personId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/risk-groups/{riskGroupId}/persons/{personId}',
            path: {
                'riskGroupId': riskGroupId,
                'personId': personId,
            },
            errors: {
                400: `The provided parameters are invalid or incomplete.`,
                401: `The user is not authorized to access this resource.`,
                403: `The user is forbidden from accessing this resource.`,
                404: `The specified Risk Group or Person was not found.`,
                409: `The person is already associated with this Risk Group.`,
            },
        });
    }
    /**
     * Retrieve person links associated with a Risk Group.
     * Provides a list of persons linked to a specific Risk Group, including their screening dates and statuses.
     * @param riskGroupId
     * @param pageNumber
     * @param pageSize
     * @param gender
     * @param birthDateFrom
     * @param birthDateTo
     * @param searchTerm
     * @param sortBy
     * @param sortDirection
     * @param includeAnonymous
     * @param includePatients
     * @param hasActiveRiskGroup
     * @param caseStatuses
     * @returns GetRiskGroupPersonsResponse The person links for the Risk Group have been retrieved successfully.
     * @throws ApiError
     */
    public static getRiskGroupPersonsEndpoint(
        riskGroupId: string,
        pageNumber: number,
        pageSize: number,
        gender?: Gender | null,
        birthDateFrom?: string | null,
        birthDateTo?: string | null,
        searchTerm?: string | null,
        sortBy?: string | null,
        sortDirection?: ListSortDirection | null,
        includeAnonymous?: boolean | null,
        includePatients?: boolean | null,
        hasActiveRiskGroup?: boolean | null,
        caseStatuses?: Array<PersonCaseStatus> | null,
    ): CancelablePromise<GetRiskGroupPersonsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/risk-groups/{riskGroupId}/persons',
            path: {
                'riskGroupId': riskGroupId,
            },
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'gender': gender,
                'birthDateFrom': birthDateFrom,
                'birthDateTo': birthDateTo,
                'searchTerm': searchTerm,
                'sortBy': sortBy,
                'sortDirection': sortDirection,
                'includeAnonymous': includeAnonymous,
                'includePatients': includePatients,
                'hasActiveRiskGroup': hasActiveRiskGroup,
                'caseStatuses': caseStatuses,
            },
            errors: {
                400: `The required parameters were not provided or are invalid.`,
                401: `The user is not authorized to access this resource.`,
                403: `The user is forbidden from accessing this resource.`,
                404: `The specified Risk Group was not found.`,
            },
        });
    }
    /**
     * Retrieve a paginated list of Risk Groups.
     * Provides a paginated list of Risk Groups with optional search and sorting capabilities.
     * @param pageNumber The page number to retrieve.
     * @param pageSize The number of items per page.
     * @param status
     * @param searchTerm An optional search term to filter results by Title, Document Number, or Legal Entity Name.
     * @param sortBy The field to sort results by. Possible values are Title, Document Number, or Total Persons.
     * @param sortDirection The direction of sorting: ascending or descending.
     * @returns GetRiskGroupListResponse The list of Risk Groups has been retrieved successfully.
     * @throws ApiError
     */
    public static getRiskGroupListEndpoint(
        pageNumber: number,
        pageSize: number,
        status?: RiskGroupStatus | null,
        searchTerm?: string | null,
        sortBy?: string | null,
        sortDirection?: ListSortDirection | null,
    ): CancelablePromise<GetRiskGroupListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/risk-groups',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'status': status,
                'searchTerm': searchTerm,
                'sortBy': sortBy,
                'sortDirection': sortDirection,
            },
            errors: {
                400: `The required parameters were not provided or are invalid.`,
                401: `The user is not authorized to access this resource.`,
                403: `The user is not authorized to access this resource.`,
            },
        });
    }
    /**
     * Create a new Risk Group.
     * Creates a new Risk Group with an optional document, legal entity, and a list of associated persons.
     * @param requestBody
     * @returns CreateRiskGroupResponse The Risk Group has been created successfully.
     * @throws ApiError
     */
    public static createRiskGroupEndpoint(
        requestBody: CreateRiskGroupRequest,
    ): CancelablePromise<CreateRiskGroupResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/risk-groups',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid request. Required parameters are missing or invalid.`,
                401: `User is not authorized.`,
                403: `User is not authorized to perform this operation.`,
                404: `The required parameters were not found.`,
            },
        });
    }
    /**
     * Retrieves available legal entities that can be attached to a risk group.
     * This endpoint returns a list of legal entity IDs that are available for association with a risk group.
     * The request requires a legal entity ID in the header.
     * @returns AvailableLegalEntitiesResponse A list of available legal entity IDs that can be attached to a risk group.
     * @throws ApiError
     */
    public static availableLegalEntitiesEndpoint(): CancelablePromise<AvailableLegalEntitiesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/risk-groups/available-legal-entities',
            errors: {
                400: `The request is invalid or missing required parameters.`,
                401: `The user is not authorized to access this resource.`,
                403: `The user does not have permission to retrieve available legal entities.`,
            },
        });
    }
}
